<template>
  <div>

  </div>
</template>

<script>
export default {
  created() {
    this.$router.push({ path: '/settings/newRuleManage/list' });
  },
}
</script>